import React, { useEffect, useState } from 'react'
import { getAllSubscriptionPlans } from '../../PaymentAndSubcription/Services/SubscriptionPlanService';
import { SubscriptionPlanResponse } from '../../PaymentAndSubcription/Types/SubscriptionPlanType';
import SubscriptionUI from '../../PaymentAndSubcription/Components/SubscriptionUIComponent';
import { useCompanyAdminAccess } from '../Hooks/useCompanyAdminAccess';


function RecruiterSubscriptionPage() {

  const [subscriptionPlans, setSubscriptionPlans] = useState<SubscriptionPlanResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // A recruiter who is not a company admin has no plan to manage, so the page
  // hides itself rather than waiting for a request the server would reject.
  const { isCompanyAdminUser, loading: accessLoading } = useCompanyAdminAccess();

    useEffect(() => {
    if (!isCompanyAdminUser) return;

  const fetchCandidates = async () => {
    try {
      const response = await getAllSubscriptionPlans();
      console.log("Subscription Plans Response:", response);
      if (response.success) {
        setSubscriptionPlans(response.data);
      }
    } catch (err) {
      setError("Failed to load subscription plans");
    } finally {
      setLoading(false);
    }
  };

  fetchCandidates();
}, [isCompanyAdminUser]);

  if (accessLoading) {
    return (
      <div className="min-h-[60vh] bg-[#F8FAFC] p-6 md:p-8 flex items-center justify-center">
        <p className="text-sm font-semibold text-slate-400">Checking your access…</p>
      </div>
    );
  }

  if (!isCompanyAdminUser) {
    return (
      <div className="min-h-[60vh] bg-[#F8FAFC] p-6 md:p-8 flex items-center justify-center">
        <div className="text-center">
          <p className="text-lg font-bold text-slate-600 mb-2">Access Restricted</p>
          <p className="text-sm text-slate-500">
            Subscription plans are managed by your company administrator.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
        <SubscriptionUI plans={subscriptionPlans} onSelect={() => {}} />
    </div>
  )
}

export default RecruiterSubscriptionPage